import { App } from 'vue';
import OfficeTypes from '../types/offices';

// Each FeatureKey should match the value of the FeatureKey on the server side
type FeatureKey = 
  'ReusePaymentAsPayoutAccount' |
  'Deliverables' | 
  'DocusignPhoneAuthIdentityVerification' | 
  'Engagements' | 
  'NewPaymentMethodsCustomers' | 
  'NewPaymentMethodsPayouts' | 
  'Acrobatsign' |
  'ExternalPayments' |
  'CheckPaymentMethod' |
  'ClientActiveStatus' | 
  'TransactionFeesUI' | 
  'InstantPayouts' |
  'CheckBlotter' |
  'ApprovalEngagements';
  'SuperadminFirmMerge';

export default {
  install: (app: App) => {
    app.config.globalProperties.$featureEnabled = (key: FeatureKey): boolean => {
      return (window as any).enabledFeatures.indexOf(key) >= 0;
    }
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    /** featureEnabled returns the list of features indicating whether they are enabled */
    $featureEnabled: (key: FeatureKey) => boolean
    $officeData: OfficeData
  }

  interface OfficeData {
    allMinimalOffices: Array<OfficeTypes.MinimalOffice>
  }
}